import api from "@/api/base";

export const fetchPortfolios = () =>
  api.get(`/portfolios/`).then((response) => response.data);

export const createPortfolio = (name: string) =>
  api.post(`/portfolios/`, { name }).then((response) => response.data);

export const addBuildingToPortfolio = (
  portfolioId: string | null,
  buildingId: string,
  isRemoval: boolean,
) =>
  api.post(`/portfolios/${portfolioId}/add_building/`, {
    building_id: buildingId,
    is_removal: isRemoval,
  });

export const addUserToPortfolio = (
  portfolioId: string | null,
  isRemoval: boolean,
) =>
  api.post(`/portfolios/${portfolioId}/add_user/`, {
    is_removal: isRemoval,
  });
